var els = $('[data-order-items]');
if (els.length > 0) {
  require.ensure('../controllers/order_items_controller', function(require) {
    var OrderItemsController = require('../controllers/order_items_controller');
    els.each(function() {
      return new OrderItemsController(this);
    });
  });
}

var orderExpenses = $('[data-expenses-overview]');
if (orderExpenses.length > 0) {
  require.ensure('../modules/order_items_index', function(require) {
    var OrderItemsIndex = require('../modules/order_items_index');
    orderExpenses.each(function() {
      return new OrderItemsIndex(this);
    });
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/order_items.initializer.js